import React, {FC, ReactNode} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import adminTracking from "@irati-tracking/admin"

import Header from "./Header"

const STEPS_COUNT = 3

const SSO_IDENTITY_PROVIDER = "SSO_confirmIdentityProvider"
const SSO_EMAIL_DOMAINS = "SSO_confirmEmailDomains"
const SSO_FINISH_SETUP = "SSO_finishOAuthSetup"

interface Props {
  step: number,
  title?: string,
  subTitle?: string,
  disabled?: boolean,
  onPrev: () => void,
  onNext: () => void,
  children?: ReactNode
}

const Step: FC<Props> = ({step, title, subTitle, disabled, onPrev, onNext, children}) => {
  const handleNext = () => {
    onNext()
    switch (step) {
      case 1:
        return adminTracking.startIntegrationsSSOJourney(SSO_IDENTITY_PROVIDER)
      case 2:
        return adminTracking.startIntegrationsSSOJourney(SSO_EMAIL_DOMAINS)
      case 3:
        return adminTracking.startIntegrationsSSOJourney(SSO_FINISH_SETUP)
      default:
        return null
    }
  }

  return (
    <Flex direction="column">
      <Header onBack={onPrev} />
      <Flex direction="column">
        {title && <H3 marginBottom={subTitle ? 1 : 4}>
          <FormattedMessage id={title} />
        </H3>}
        {subTitle && <Body marginBottom={4}>
          <FormattedMessage id={subTitle} />
        </Body>}
        {children}
        <Flex justifyContent="space-between">
          <Body marginTop={3}>
            <FormattedMessage
              id="admin.components.integration.sso.enableSSO.oauth.steps"
              values={{no: step, count: STEPS_COUNT}} />
          </Body>
          <Button id={step === 3 ? "finish_button" : "next_button"}primary onClick={handleNext} disabled={disabled}>
            {step === 3
              ? <FormattedMessage id="admin.components.integration.sso.enableSSO.start.finishBtn" />
              : <FormattedMessage id="admin.components.integration.sso.enableSSO.start.nextBtn" />
            }
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Step
